import { createSelector } from 'reselect'
import { STABLE_EMPTY_ARRAY } from '@feedyou/utils'

import { applyForcedBotFeatures, forcedBotFeaturesSelector } from '../../devTools'
import { botHostingMetadataSelector } from './botHostingMetadataSelector'
import { RootState } from '../../../reducers'

export const sdkFeaturesSelector = createSelector(
  (state: RootState) => botHostingMetadataSelector(state)?.buildInfo?.sdkFeatures,
  forcedBotFeaturesSelector,
  (sdkFeatures = STABLE_EMPTY_ARRAY, forcedSdkFeatures) => {
    return applyForcedBotFeatures(sdkFeatures, forcedSdkFeatures)
  }
)
